import Toast from "../modal/toast";

const URLS = {
    orderGet: "/api/order/get",
    orderCreate: "/api/order/create",
    addItem: (orderId) => `/api/order/${ orderId }/addItem`,
    removeItem: (orderId, itemId) => `/api/order/${ orderId }/${ itemId }/remove`
};

export default class Order {
    form = null
    cart = null
    contacts = null
    order = null

    static names = {
        banner: "Баннер",
        vacancy: "Вакансия",
        event: "Мероприятие"
    }

    constructor(form, cart = null) {
        this.form = form;
        this.cart = cart || document.querySelector(".cart");
        this.contacts = document.querySelector("[data-payment-contacts]");

        this.initForm();
        this.initCart();
        this.initPayment();
    }

    addItem(type, id) {
        const body = new FormData();

        body.append("type", type);
        body.append("uuid", id);

        return this.requestOrder()
            .then(() => fetch(URLS.addItem(this.order.orderId), {
                method: "POST",
                body: body }))
            .then(res => res.json())
            .then(json => {
                if (json.success == 1) {
                    this.order.products.push({
                        itemId: json.id,
                        productId: id,
                        name: type,
                        price: json.price
                    });
                    this.renderOrder();
                }
            });
    }

    renderOrder() {
        const items = this.cart.querySelector(".cart__items");
        const emptyMsg = this.cart.querySelector(".cart__empty-msg");
        let totalSum = 0;

        items.classList.toggle("d-none", this.order.products.length === 0);
        emptyMsg.classList.toggle("d-none", this.order.products.length !== 0);

        while (items.firstChild)
            items.removeChild(items.firstChild);

        for (const product of this.order.products) {
            items.appendChild(this.renderOrderItem(product));
            totalSum += +product.price;
        }

        this.cart.querySelector(".cart__summary-val").textContent = this.formatNumber(totalSum);
        this.updateReceipt();
    }

    renderOrderItem(item) {
        const li = document.createElement("li");

        li.classList.add("cart__item");

        li.innerHTML = `
            <div class="flex align-between valign-center">
                <input type="hidden" disabled name="itemId" value="${ item.itemId }">
                <a class="accent-color no-link" href="javascript:void 0;">${ Order.names[item.name] }</a>
                <button class="error-color" data-remove-item>
                    <svg width="10" height="10">
                        <use href="#close-icon" xlink:href="#close-icon">
                    </svg>
                </button>
            </div>
            <div class="text-color">
                ${ this.formatNumber(item.price) } ₽
            </div>
        `;

        return li;
    }

    updateReceipt() {
        if (!this.form.elements.receipt) {
            return;
        }

        const contact = this.contacts?.elements.contact?.value;
        const taxation = "osn";
        const items = this.order.products.map(product => ({
            Name: Order.names[product.name],
            Price: parseInt(product.price) * 100,
            Quantity: 1,
            Amount: parseInt(product.price) * 100,
            Tax: "none"
        }));
        const receipt = {
            Email: contact,
            Taxation: taxation,
            Items: items
        };

        this.form.elements.receipt.value = JSON.stringify(receipt);
    }

    requestOrder() {
        if (this.order) {
            return Promise.resolve(this.order);
        }
        else {
            return fetch(URLS.orderCreate)
                .then(res => res.json())
                .then(json => this.order = { orderId: json.orderId, products: [] });
        }
    }

    showPaymentForm() {
        this.form.querySelector("[name=order]").value = this.order.orderId;
        this.form.querySelector("[name=amount]").value = this.order.products
            .reduce((acc, val) => acc + +val.price, 0);

        window.pay(this.form);
    }

    formatNumber(number) {
        number = number.toString();

        return [ ...[ ...number ]
            .reverse()
            .join("")
            .replace(/(.{3})/g, c => c + " ") ]
        .reverse()
        .join("");
    }

    initForm() {
        this.form.onsubmit = (event) => {
            event.preventDefault();

            this.requestOrder()
                .then(() => {
                    const body = new FormData(this.contacts);

                    body.append("orderId", this.order.orderId);

                    return fetch(this.contacts.action, {
                        method: this.contacts.method,
                        body: body
                    });
                })
                .then(() => {
                    if (this.order.products.length === 0) {
                        Toast.open("Корзина заказа пуста", { state: "error" });
                    }
                    else {
                        this.showPaymentForm();
                    }
                });
        };
    }

    initCart() {
        fetch(URLS.orderGet)
            .then(res => res.json())
            .then(json => {
                this.order = json.exists ? json.order : null;

                if (this.order) {
                    this.renderOrder();
                }
                else {
                    this.disableForm();
                }
            });
        
        this.cart.addEventListener("click", (e) => {
            let element = null;

            if (element = e.target.closest("[data-remove-item]")) {
                const container = element.closest("li");
                const itemId = container.querySelector("[name=itemId]").value;

                fetch(URLS.removeItem(this.order.orderId, itemId), {
                    method: "POST"
                })
                .then(res => res.json())
                .then(json => {
                    if (json.success == 1) {
                        const idx = this.order.products.findIndex(item => item.itemId === itemId);

                        this.order.products.splice(idx, 1);
                        this.renderOrder();
                    }
                    else {
                        Toast.open("Произошла ошибка", { state: "error" });
                    }
                });
            }
        });
    }

    initPayment() {
        const resetPayment = () => {
            this.order = { products: [] };
            this.renderOrder();
            this.order = null;
        };

        window.addEventListener("message", ({ data }) => {
            if (data === "payment-success") {
                resetPayment();
            }
        });
    }

    disableForm() {
    }
}
